<template>
  <div class="section-nav">
    <button
      v-for="(item, index) in sections"
      :key="item.id"
      type="button"
      @click="$emit('scroll', item.id)"
    >
      <span class="step">{{ index + 1 }}</span>
      <span class="copy">
        <strong>{{ item.label }}</strong>
        <em>{{ item.desc }}</em>
      </span>
      <span v-if="index < sections.length - 1" class="arrow">→</span>
    </button>
  </div>
</template>

<script>
/** 四个环节锚点导航，点击滚动到对应卡片 */
export default {
  name: 'SectionNav',
  props: {
    sections: { type: Array, default: () => [] }
  }
};
</script>
